<template>
  <div v-if="errorMessage != ''">
    <div class="content">
      <h1>{{ errorMessage }}</h1>
    </div>
  </div>
  <progress
    v-else-if="!marketAvailable || !siteAvailable"
    class="progress is-small is-primary"
    max="100"
    >Fetching</progress
  >
  <div v-else>
    <article class="media">
      <figure class="media-left is-hidden-mobile">
        <p class="image is-128x128">
          <a :href="'/site/' + market.site"
            ><img
              :src="
                'https://my.biddingmate.com.au/logos/' + market.site + '.png'
              "
              style="border-radius:10rem"
              :alt="site.sitename"
          /></a>
        </p>
      </figure>
      <div class="media-content">
        <div class="content">
          <p>
            <router-link :to="'/market/' + market.saleId" class="subtitle"
              ><h1 class="title">
                {{ market.saleDescription }}
              </h1></router-link
            >
            <span class="subtitle"
              >{{ market.scheduled.toLocaleString()
              }}<!-- | 1.5M HEAD--></span
            >
            <br />
            <small>{{ site.sitename }} | {{ site.location }}</small>
          </p>
          <p class="control">
            <a
              class="button is-white is-large"
              :href="'https://' + site.mediaServer"
            >
              WATCH LIVE&nbsp;
              <span class="icon">
                <i class="zmdi zmdi-arrow-right"></i>
              </span>
            </a>
          </p>
        </div>
      </div>
    </article>
    <br />
    <div class="upcoming">
      <div class="currentmarket">
        <h2 class="title">Catalogue of {{ catalogue.length }} lots</h2>
        <article class="media" v-for="(lot, index) in catalogue" :key="index">
          <figure class="media-left">
            <p class="title">
              {{ index + 1 }}
            </p>
          </figure>
          <div class="media-content">
            <div class="content">
              <p>
                <a class="subtitle" :href="'https://' + site.mediaServer">{{
                  market.saleDescription
                }}</a
                ><br />
                <small>{{ site.location }} | {{ market.scheduled }}</small>
              </p>
            </div>
          </div>
          <div class="media-right">
            <a class="image is-64x64">
              <span class="icon">
                <i class="zmdi zmdi-chevron-down  zmdi-hc-2x"></i>
              </span>
            </a>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import log from 'loglevel'
import { icsFormatter } from '../ics'
import { proapps } from '../common/proapps'

export default {
  name: 'Home',
  metaInfo() {
    return {
      title: this.market.saleDescription,
      meta: [
        {
          name: 'description',
          content:
            this.market.saleDescription + ' Scheduled: ' + this.market.scheduled
        }
      ]
    }
  },
  components: {},
  data() {
    return {
      description: '',
      marketAvailable: false,
      siteAvailable: false,
      errorMessage: '',
      market: {
        saleDescription: '',
        scheduled: new Date()
      },
      site: null,
      catalogue: []
    }
  },
  mounted() {
    log.info('MarketDetail mounted')

    let headers = new Headers()
    let token = sessionStorage.getItem('access_token')
    if (token != null && token.length > 0) {
      headers.append(
        'Authorization',
        'Bearer ' + sessionStorage.getItem('access_token')
      )
    }

    // Get markets
    proapps
      .getMarket(this.$route.params.id)
      .then(response => {
        this.market = response
        this.marketAvailable = true

        // Get sites
        proapps
          .getSite(this.market.site)
          .then(response => {
            this.site = response
            this.siteAvailable = true
          })
          .catch(err => {
            log.error(err)
          })
      })
      .catch(err => {
        log.error(err)
        this.errorMessage = err
      })
  },
  destroyed() {
    log.info('MarketDetail destroyed')
  },
  methods: {
    getICS(market) {
      this.ics = icsFormatter()
      var begin = new Date(market.scheduled)
      var end = new Date(begin.getTime() + 60 * 60000)
      this.ics.addEvent(
        market.saleDescription,
        market.saleDescription,
        this.site.location,
        begin.toUTCString(),
        end.toUTCString()
      )
      this.ics.download(market.site, '.ics')
    },
    isLive(market) {
      var begin = new Date(market.scheduled)
      return begin >= new Date()
    }
  }
}
</script>
